var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBuy(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 32,
    viewBox: "0 0 37 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_8246_1199)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.9999 19.8323C35.0028 20.0796 34.9544 20.3225 34.861 20.529C34.7676 20.7356 34.6335 20.8964 34.4763 20.9902C34.319 21.084 34.146 21.1066 33.9799 21.0549C33.8137 21.0032 33.6621 20.8797 33.545 20.7006L29.6385 15.004L20.6107 26.2808C20.3803 26.6345 20.1028 26.9162 19.7951 27.1087C19.4875 27.3012 19.1561 27.4005 18.8212 27.4005C18.4863 27.4005 18.1549 27.3012 17.8472 27.1087C17.5396 26.9162 17.2621 26.6345 17.0316 26.2808L11.583 17.2382L1.87867 29.6268C1.80186 29.7447 1.70936 29.8386 1.6068 29.9027C1.50424 29.9669 1.39378 30 1.28215 30C1.17052 30 1.06006 29.9669 0.9575 29.9027C0.854943 29.8386 0.762441 29.7447 0.685633 29.6268L0.256432 29.002C0.175425 28.8902 0.110911 28.7556 0.0668242 28.6063C0.0227368 28.457 0 28.2963 0 28.1338C0 27.9713 0.0227368 27.8105 0.0668242 27.6612C0.110911 27.5119 0.175425 27.3773 0.256432 27.2655L9.80069 8.31201C10.0311 7.95828 10.3086 7.67657 10.6163 7.48406C10.924 7.29154 11.2553 7.19226 11.5902 7.19226C11.9251 7.19226 12.2565 7.29154 12.5642 7.48406C12.8719 7.67657 13.1494 7.95828 13.3798 8.31201L18.8285 16.2428L24.3644 6.94609L20.7853 2.23418C20.669 2.05063 20.5903 1.82323 20.5584 1.57784C20.5264 1.33246 20.5424 1.07894 20.6046 0.846151C20.6668 0.613359 20.7726 0.410636 20.91 0.261047C21.0474 0.111459 21.2109 0.0210121 21.3818 0H33.2976C33.5228 0.0149152 33.7438 0.0945283 33.9478 0.234255C34.1518 0.373982 34.3348 0.571061 34.4863 0.814149C34.6377 1.05724 34.7546 1.34153 34.8303 1.65066C34.906 1.95979 34.9389 2.28765 34.9271 2.61537L34.9999 19.8323Z",
    fill: "#3CD856"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_8246_1199",
    x: 0,
    y: 0,
    width: 37,
    height: 32,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_8246_1199"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_8246_1199",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuy);
export default __webpack_public_path__ + "static/media/Buy.f10f933d10c1f1f625c4d84869395519.svg";
export { ForwardRef as ReactComponent };